const EVAL_SERVICE_BASE_URL = process.env.EVAL_SERVICE_BASE_URL
const SD_CTA_JUDGE_ID = 'f0913a4b-73fe-42db-bac4-df46bbb69e6f'
const SD_CTA_VARIANTS_THAT_SHOW = ['variantA', 'variantB', 'variantC']

interface SendEvaluationInput {
  experimentName: string
  messageId: string
  assistantResponse: string
  chatHistory: Array<{ type: 'user'; message: string }>
  judgeId: string
}

export interface BuildSeusDireitosExperimentNameParams {
  page: string
  experimentId: string
  variant: string
}

export interface SendSeusDireitosCtaEvaluationParams {
  experimentName: string
  searchTerm: string
}

export interface ShouldSendSeusDireitosEvalParams {
  variant: string
  searchTerm: string
}

async function sendEvaluation(input: SendEvaluationInput): Promise<void> {
  const body = {
    input: {
      judgeId: input.judgeId,
      evalRunName: input.experimentName,
      assistantResponse: input.assistantResponse,
      messageId: input.messageId,
      chatHistory: input.chatHistory,
    },
  }

  try {
    const response = await fetch(`${EVAL_SERVICE_BASE_URL}/eval-cases`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    if (response.status >= 400) {
      console.warn(`[SeusDireitos Eval] ${response.status}:`, await response.text().catch(() => ''))
    }
  } catch (e) {
    console.warn('[SeusDireitos Eval] Error posting evaluation:', e)
  }
}

export function shouldSendSeusDireitosEval({
  variant,
  searchTerm,
}: ShouldSendSeusDireitosEvalParams): boolean {
  return (
    variant != null && SD_CTA_VARIANTS_THAT_SHOW.includes(variant) && Boolean(searchTerm.trim())
  )
}

export function buildSeusDireitosExperimentName({
  page,
  experimentId,
  variant,
}: BuildSeusDireitosExperimentNameParams): string {
  return `seus-direitos::feat-not-found-cta::${page}::${experimentId}::${variant}`
}

export function sendSeusDireitosCtaEvaluation({
  experimentName,
  searchTerm,
}: SendSeusDireitosCtaEvaluationParams): void {
  sendEvaluation({
    experimentName,
    messageId: 'fake-message-id',
    assistantResponse: 'fake-assistant-response',
    chatHistory: [{ type: 'user', message: searchTerm }],
    judgeId: SD_CTA_JUDGE_ID,
  })
}
